export default {"src":"/_next/static/media/x.04d98b5c.svg","height":22,"width":24,"blurWidth":0,"blurHeight":0};